import * as React from 'react';
import * as styles from '../FeedAdmin.css';
import { Store } from '../stores';
import { inject, observer } from 'mobx-react';
import { IASkeleton } from '../../skeleton/Skeleton';
import { IAButton } from '../../button/Button';
import { LocalizationService } from '../../../services/LocalizationService';
import { FeedCreatorPanel } from './FeedCreatorPanel';
// import { IAIcon } from '../../icon/Icon';
import { IAPopup } from '../../popup/Popup';
import FeedService from '../../../services/FeedService';
import StructureViewer from '../../structureViewer/StructureViewer';
import { IStructureElement } from '../../structureViewer/IStructureElement';
import { IFeedStructureItem } from '../../../interfaces/IFeed';
import { FeedStructureHeaderEditPanel } from './FeedStructureHeaderEditPanel';
import { FeedSelectorPanel } from './FeedSelectorPanel';
import { IAIcon } from '../../icon/Icon';

export interface IProps {
  store?: Store;
  onFeedUpdatedOrCreated: () => void;
}

export interface IState {
  isDeletingFeed: boolean;
  showAddFeedDropdown: boolean;
}

@inject('store')
@observer
export class FeedOverview extends React.Component<IProps, IState> {
  private readonly localizationService: LocalizationService = new LocalizationService();
  private menuRef: HTMLDivElement;

  constructor(props: IProps) {
    super(props);
    this.state = {
      isDeletingFeed: false,
      showAddFeedDropdown: false
    }
  }

  public componentDidMount() {
    document.addEventListener('mousedown', (e) => this.handleClick(e))
  }

  public componentWillUnmount() {
    document.removeEventListener('mousedown', (e) => this.handleClick(e));
  }

  private handleClick(event: Event) {
    if (this.menuRef && !this.menuRef.contains(event.target as Node)) {
      if (this.state.showAddFeedDropdown) {
        this.setState({ showAddFeedDropdown: false })
      }
    }
  }

  private convertFeedStructure(item: IFeedStructureItem): IStructureElement {
    const isFeed = !!item.id;
    const originalFeed = this.props.store.feeds?.find(feed => feed.id === item.id);
    item.feed = originalFeed;
    return {
      id: item.id,
      type: isFeed ? "element" : "header",
      iconUrl: isFeed ? "https://intraactivestorage.blob.core.windows.net/cdn/icons/RSS/SVG/ic_fluent_rss_24_regular.svg" : "https://intraactivestorage.blob.core.windows.net/cdn/icons/Text/SVG/ic_fluent_text_32_regular.svg",
      highlighted: item.highlighted,
      title: isFeed ? originalFeed?.title ?? "" : item.title,
      children: item.children?.map(child => this.convertFeedStructure(child)),
      originalElement: item,
      titleSubcomponent: isFeed ? <div className={styles.FeedAdmin_InstancesWrapper}>{originalFeed?.instances?.map(instance => <span style={{backgroundColor: this.props.store.highlightColor}}>{instance}</span>)}</div> : undefined
    }
  }

  private createFeedStructure() {
    FeedService.createFeedStructure(this.props.store.environment, this.props.store.tenant, this.props.store.selectedApplication, this.props.store.structuredFeeds)
    .then((structure) => {
      this.props.store.structuredFeedsBeforeChanges = JSON.parse(JSON.stringify(structure));
      this.props.store.structuredFeeds = JSON.parse(JSON.stringify(structure));
      this.forceUpdate();
    })
    .finally(() => this.props.store.isSavingStructure = false);
  }

  private updateFeedStructure() {
    FeedService.updateFeedStructure(this.props.store.environment, this.props.store.tenant, this.props.store.selectedApplication, this.props.store.structuredFeeds)
    .then((structure) => {
      this.props.store.structuredFeedsBeforeChanges = JSON.parse(JSON.stringify(structure));
      this.props.store.structuredFeeds = JSON.parse(JSON.stringify(structure));
      this.forceUpdate();
    })
    .finally(() => this.props.store.isSavingStructure = false);
  }

  public render(): JSX.Element {
    return <>
      <div
        ref={ref => this.menuRef = ref}
        style={{
          position: "relative",
          marginBottom: 20,
          width: "fit-content"
        }}
      >
        <IAButton
          label={this.localizationService.strings.Admin_Add}
          icon="Add"
          iconColor={"#ffffff"}
          textColor={"#ffffff"}
          borderRadius={5}
          disbaled={this.props.store.isLoadingFeeds}
          buttonColor={this.props.store.highlightColor}
          onClick={() => this.setState({showAddFeedDropdown: true})}
          style={{
            width: "fit-content"
          }}
        />
        {this.state.showAddFeedDropdown &&
          <ul className={styles.IA_cardBarItems}>
            <div
              className={styles.IA_commandBarItem}
              onClick={() => {
                this.props.store.feedToEdit = {
                  title: "",
                  application: this.props.store.selectedApplication,
                  instances: []
                }
              }}
            >
              <IAIcon
                url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Add/SVG/ic_fluent_add_28_regular.svg"
                size={14}
                color={this.props.store.highlightColor}
                style={{
                  float: "left",
                }}
              />
              <div
                style={{
                  color: "#333333",
                  float: "left",
                  marginLeft: 7,
                }}
              >
                {this.localizationService.strings.FeedAdmin_CreateNewFeed}
              </div>
            </div>
            <div
              className={styles.IA_commandBarItem}
              onClick={() => {
                this.props.store.isAddingTopLevelGroupHeader = true;
                this.props.store.headerToEdit = {
                  title: "",
                  children: []
                };
              }}
            >
              <IAIcon
                url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Text%20Add/SVG/ic_fluent_text_add_20_regular.svg"
                size={14}
                color={this.props.store.highlightColor}
                style={{
                  float: "left",
                }}
              />
              <div
                style={{
                  color: "#333333",
                  float: "left",
                  marginLeft: 7,
                }}
              >
                {this.localizationService.strings.TargetingAdmin_AddGroupHeader}
              </div>
            </div>
            <div
              className={styles.IA_commandBarItem}
              onClick={() => {
                this.props.store.isAddingTopLevelFeed = true;
                
              }}
            >
              <IAIcon
                url="https://intraactivestorage.blob.core.windows.net/cdn/icons/RSS/SVG/ic_fluent_rss_24_regular.svg"
                size={14}
                color={this.props.store.highlightColor}
                style={{
                  float: "left",
                }}
              />
              <div
                style={{
                  color: "#333333",
                  float: "left",
                  marginLeft: 7,
                }}
              >
                {this.localizationService.strings.FeedAdmin_AddFeedToStructure}
              </div>
            </div>
          </ul>
        }
        <IAButton
          label={this.localizationService.strings.Admin_Save}
          textColor={"#ffffff"}
          borderRadius={5}
          disbaled={this.props.store.isLoadingFeeds || JSON.stringify(this.props.store.structuredFeeds) === JSON.stringify(this.props.store.structuredFeedsBeforeChanges)}
          showSpinner={this.props.store.isSavingStructure}
          buttonColor={this.props.store.highlightColor}
          onClick={() => {
            this.props.store.isSavingStructure = true;
            if (this.props.store.isStartingFromScratch) {
              this.createFeedStructure();
            } else {
              this.updateFeedStructure();
            }
          }}
          style={{
            width: "fit-content",
            marginLeft: 10
          }}
        />
        <IAButton
          label={this.localizationService.strings.Admin_Cancel}
          textColor={"#ffffff"}
          borderRadius={5}
          disbaled={this.props.store.isLoadingFeeds || JSON.stringify(this.props.store.structuredFeeds) === JSON.stringify(this.props.store.structuredFeedsBeforeChanges)}
          buttonColor={"gray"}
          onClick={() => {
            this.props.store.structuredFeeds = JSON.parse(JSON.stringify(this.props.store.structuredFeedsBeforeChanges));
            this.props.store.unstructuredFeeds = JSON.parse(JSON.stringify(this.props.store.unstructuredFeedsBeforeChanges));
          }}
          style={{
            width: "fit-content",
            marginLeft: 10
          }}
        />
      </div>
      {this.props.store.isLoadingFeeds
      ?
        <>
          {Array(5).fill(null).map(() => {
            return <IASkeleton
              skeleton={{
                height: 34,
                width: "100%",
                borderRadius: 5,
                marginBottom: 5
              }}
            />;
          })}
        </>
      : 
        <>
          {(this.props.store.isStartingFromScratch && this.props.store.structuredFeeds.length === 0) &&
            <p className={styles.FeedAdmin_WrapperParagraph}><i>{this.localizationService.strings.FeedAdmin_NoStructureSetUp}</i></p>
          }
          <StructureViewer
            highlightColor={this.props.store.highlightColor}
            structure={this.props.store.structuredFeeds?.map(feed => this.convertFeedStructure(feed))}
            elementActions={[
              {
                actionTitle: () => this.localizationService.strings.Card_CommandBar_Edit,
                iconUrl: "https://intraactivestorage.blob.core.windows.net/cdn/icons/Edit/SVG/ic_fluent_edit_48_regular.svg",
                action: (element) => this.props.store.feedToEdit = (element.originalElement as IFeedStructureItem).feed,
                isEnabled: ({element}) => element.type === "element"
              },
              {
                actionTitle: () => this.localizationService.strings.Card_CommandBar_Edit,
                iconUrl: "https://intraactivestorage.blob.core.windows.net/cdn/icons/Edit/SVG/ic_fluent_edit_48_regular.svg",
                action: (element) => this.props.store.headerToEdit = element.originalElement,
                isEnabled: ({element}) => element.type === "header"
              },
              {
                actionTitle: () => this.localizationService.strings.FeedAdmin_AddFeedToStructure,
                iconUrl: "https://intraactivestorage.blob.core.windows.net/cdn/icons/RSS/SVG/ic_fluent_rss_24_regular.svg",
                action: (element) => this.props.store.parentToAddFeedsTo = element.originalElement,
                isEnabled: ({element}) => element.type === "header"
              },
              {
                actionTitle: () => this.localizationService.strings.TargetingAdmin_AddGroupHeader,
                iconUrl: "https://intraactivestorage.blob.core.windows.net/cdn/icons/Text%20Add/SVG/ic_fluent_text_add_20_regular.svg",
                action: (element) => {
                  this.props.store.isAddingTopLevelGroupHeader = false;
                  this.props.store.headerToEdit = {
                    title: "",
                    children: []
                  };
                  this.props.store.parentToAddHeaderTo = element.originalElement;
                },
                isEnabled: ({element}) => element.type === "header"
              },
              {
                actionTitle: () => this.localizationService.strings.TargetingAdmin_MoveUp,
                iconUrl: "https://intraactivestorage.blob.core.windows.net/cdn/icons/Arrow%20Up/SVG/ic_fluent_arrow_up_48_regular.svg",
                action: (element) => {
                  this.props.store.moveItem(element.originalElement, "up");
                  this.forceUpdate();
                },
                isEnabled: ({index}) => index !== 0
              },
              {
                actionTitle: () => this.localizationService.strings.TargetingAdmin_MoveDown,
                iconUrl: "https://intraactivestorage.blob.core.windows.net/cdn/icons/Arrow%20Down/SVG/ic_fluent_arrow_down_48_regular.svg",
                action: (element) => {
                  this.props.store.moveItem(element.originalElement, "down");
                  this.forceUpdate();
                },
                isEnabled: ({index, parentChildrenCount}) => index !== parentChildrenCount - 1
              },
              {
                actionTitle: () => this.localizationService.strings.TargetingAdmin_MoveOut,
                iconUrl: "https://intraactivestorage.blob.core.windows.net/cdn/icons/Arrow%20Enter%20Up/SVG/ic_fluent_arrow_enter_up_24_regular.svg",
                action: (element) => {
                  this.props.store.moveItemOut(element.originalElement);
                  this.forceUpdate();
                },
                isEnabled: ({isTopLevel}) => !isTopLevel
              },
              {
                actionTitle: (props) => props?.isHighlighted ? this.localizationService.strings.TargetingAdmin_RemoveHighlight : this.localizationService.strings.TargetingAdmin_Highlight,
                iconUrl: "https://intraactivestorage.blob.core.windows.net/cdn/icons/Highlight/SVG/ic_fluent_highlight_24_regular.svg",
                action: (element) => {
                  this.props.store.setHighlightForItemInGroups(element.originalElement);
                  this.forceUpdate();
                },
                isEnabled: () => true
              },
              {
                actionTitle: () => this.localizationService.strings.FeedAdmin_RemoveFromStructure,
                iconUrl: "https://intraactivestorage.blob.core.windows.net/cdn/icons/Eraser/SVG/ic_fluent_eraser_24_regular.svg",
                action: (element) => {
                  this.props.store.deleteItemInGroups(element.originalElement);
                  this.forceUpdate();
                },
                isEnabled: () => true
              },
              {
                actionTitle: () => this.localizationService.strings.FeedAdmin_DeleteFeed,
                iconUrl: "https://intraactivestorage.blob.core.windows.net/cdn/icons/Eraser/SVG/ic_fluent_eraser_24_regular.svg",
                action: (element) => this.props.store.feedToDelete = element.originalElement as IFeedStructureItem,
                isEnabled: ({element}) => element.type === "element"
              }
            ]}
          />
          <p className={styles.FeedAdmin_WrapperParagraph}>{this.localizationService.strings.FeedAdmin_FeedsNotYetAdded}</p>
          <StructureViewer
            highlightColor={this.props.store.highlightColor}
            structure={this.props.store.unstructuredFeeds?.map(feed => this.convertFeedStructure(feed))}
            elementActions={[
              {
                actionTitle: () => this.localizationService.strings.FeedAdmin_DeleteFeed,
                iconUrl: "https://intraactivestorage.blob.core.windows.net/cdn/icons/Eraser/SVG/ic_fluent_eraser_24_regular.svg",
                action: (element) => this.props.store.feedToDelete = element.originalElement as IFeedStructureItem,
                isEnabled: () => true
              }
            ]}
          />
        </>
      }
      {this.props.store.feedToDelete?.feed && 
        <IAPopup
          headline={this.localizationService.strings.FeedAdmin_DeletingFeed}
          content={<div
            style={{
              display: "flex",
              flexDirection: "column"
            }}
          >
            <p>{this.props.store.feedToDelete.feed.title}</p>
            <div
              style={{
                display: "flex",
                flexDirection: "row"
              }}
            >
              <IAButton
                label={this.localizationService.strings.Admin_Delete}
                iconUrl="https://intraactivestorage.blob.core.windows.net/cdn/icons/Delete/SVG/ic_fluent_delete_48_regular.svg"
                iconColor={"#ffffff"}
                textColor={"#ffffff"}
                borderRadius={5}
                showSpinner={this.state.isDeletingFeed}
                buttonColor={this.props.store.highlightColor}
                onClick={() => {
                  this.setState({ isDeletingFeed: true });
                  FeedService.deleteFeed(this.props.store.environment, this.props.store.tenant, this.props.store.token, this.props.store.feedToDelete.feed.id)
                    .then(() => {
                      if (!this.props.store.isStartingFromScratch) {
                        this.props.store.deleteItemInGroups(this.props.store.feedToDelete);
                        this.updateFeedStructure();
                      }

                      this.props.store.feedToDelete = undefined;
                      this.props.onFeedUpdatedOrCreated();
                    })
                    .finally(() => this.setState({ isDeletingFeed: false }))
                }} 
                style={{
                  marginRight: 10
                }}
              />
              <IAButton
                label={this.localizationService.strings.Admin_Cancel}
                iconUrl="https://intraactivestorage.blob.core.windows.net/cdn/icons/Delete/SVG/ic_fluent_delete_48_regular.svg"
                iconColor={"#ffffff"}
                textColor={"#ffffff"}
                borderRadius={5}
                disbaled={this.state.isDeletingFeed}
                buttonColor={"grey"}
                onClick={() => this.props.store.feedToDelete = undefined}
              />
            </div>
          </div>}
          close={() => {
            if (!this.state.isDeletingFeed) {
              this.props.store.feedToDelete = undefined;
            }
          }}
        />
      }
      <FeedCreatorPanel
        onClosePanel={() => {
          this.props.store.feedToEdit = undefined;
        }}
        onFeedUpdatedOrCreated={() => this.props.onFeedUpdatedOrCreated()}
      />
      <FeedStructureHeaderEditPanel
        onClosePanel={() => {
          this.props.store.headerToEdit = undefined;
          this.forceUpdate();
        }}
      />
      <FeedSelectorPanel
        onClosePanel={() => {
          this.props.store.parentToAddFeedsTo = undefined;
          this.props.store.isAddingTopLevelFeed = undefined;
        }}
        selectedFeeds={(feeds) => {
          if (this.props.store.isAddingTopLevelFeed) {
            this.props.store.structuredFeeds.push(...feeds);
            this.props.store.isAddingTopLevelFeed = false;
          } else {
            this.props.store.parentToAddFeedsTo.children = this.props.store.parentToAddFeedsTo.children ?? [];
            this.props.store.parentToAddFeedsTo.children.push(...feeds);
            this.props.store.parentToAddFeedsTo = undefined;
          }
          this.props.store.unstructuredFeeds = this.props.store.unstructuredFeeds.filter(feed => !feeds.includes(feed));
        }}
      />
    </>
  }
}